// Actions Contacts
export const SET_ACTIVE_CONTACT = "SET_ACTIVE_CONTACT";
export const UPDATE_IFRAME = "UPDATE_IFRAME";
export const TYPE_UPDATE_IFRAME = "TYPE_UPDATE_IFRAME";
export const SET_TAG_LVL = "SET_TAG_LVL";
